import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@/utils/axios';
import { REVENDA_ROTAS } from '@/utils/apiRoutes';

export const useFabricantesStore = defineStore('fabricantes', () => {
  const fabricantes = ref([]);
  const loading = ref(false);
  const error = ref(null);

  /**
   * Busca os fabricantes (marcas) disponíveis no sistema
   * @returns {Promise<Array>} Lista formatada de fabricantes
   */
  const buscarFabricantes = async () => {
    loading.value = true;
    error.value = null;

    try {
      const response = await useApi(REVENDA_ROTAS.BUSCAR_FABRICANTES).fetch({ 
        params: { status: 1 } 
      });
      
      if (response?.status === 'success' && Array.isArray(response.data)) {
        fabricantes.value = response.data.map(fabricante => ({
          title: fabricante.nome,
          value: fabricante.id.toString(),
          logo: fabricante.logo,
          bgcolor: fabricante.bgcolor,
          txtcolor: fabricante.txtcolor
        }));
        
        // Adicionar a opção "Todos" no início do array
        fabricantes.value.unshift({ title: 'Todos', value: '0' });
        
        return fabricantes.value;
      } else {
        throw new Error('Resposta inválida da API');
      }
    } catch (err) {
      error.value = err.message || 'Erro ao buscar fabricantes';
      console.error('Erro ao buscar fabricantes:', err);
      return [];
    } finally {
      loading.value = false;
    }
  };

  return {
    fabricantes,
    loading,
    error,
    buscarFabricantes
  };
});
